module.exports = __webpack_public_path__ + "static/media/Apple Watch 44mm Space Black Stainless Steel + Alaskan Blue Open.508b35dd.png";